module.exports = __webpack_public_path__ + "1d9aff75f14e220de9d479d011c60b11.svg";